import React from 'react';
import CardBanner from './CardBanner';
import CardContents from './CardContents';
import { CardProvider } from './CardContext';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';
import * as S from './styles';
import { CardProps } from './types';

/**
 * Card component.  Typically used along with `Dialog` to build modal dialogs.
 */
export function Card({
  children,
  className,
  footer,
  fullScreen = false,
  header,
  style,
}: CardProps): React.ReactElement | null {
  // providing empty header and footer components when the corresponding props
  // are undefined helps maintain the correct layout and spacing of the card
  return (
    <CardProvider fullScreen={fullScreen}>
      <S.Root {...{ className, fullScreen, style }}>
        {header ?? <CardHeader />}
        {children}
        {footer ?? <CardFooter />}
      </S.Root>
    </CardProvider>
  );
}

Card.Banner = CardBanner;
Card.Contents = CardContents;
Card.Footer = CardFooter;
Card.Header = CardHeader;

export default Card;
